export default __webpack_public_path__ + "static/media/page-not-found.01c812bf.svg";